import React, { useState, useEffect } from "react";
import { useDrop } from "react-dnd";

const AutomGroupList = ({ index, group, tab, tabChange, handleOnDrop }) => {
    const [{ isOver }, drop] = useDrop({
        accept: 'draggableItem',
        drop: (item, monitor) => {
            if (handleOnDrop) {
                handleOnDrop(item, group.id); // Hangi alana düşürüldüğünü iletmek için id'yi kullanın
            }
        },
        collect: monitor => ({
            isOver: !!monitor.isOver(),
        }),
    });

    return (
        <div ref={drop} key={group.id} className={`third-level-menu-item-row group-item ${index === 0 ? "first-group-item" : ""}  ${tab === group.name ? "active-menu" : ""}`}
            onClick={() => tabChange(group.name, group.id, group.color)} >
            <div
                id={`all-flows-menu`}
                className={`third-level-menu-item`}
            >
                <p style={{ margin: "0" }}>
                    {group.name}
                </p>
            </div>
            <div style={{ backgroundColor: `${group.color}`, minWidth: "26.64px", fontWeight: "400", marginRight: "30px" }} className={"automs-count-div"}>
                {group.autom_count}
            </div>
        </div>
    );
};

export default AutomGroupList;
